import type { InjectionKey } from 'vue';

export const menuButtonInjectionKey = Symbol('MenuButton') as InjectionKey<{
  close: () => void;
}>;
